'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProductModel;


function ProductModel($resource) {
    "ngInject";
    var resource = $resource('/cms-ajax', {
        section: '@section'
    }, {
        'getProducts': { method: 'GET', params: { section_id: '@section_id', configuration_id: '@configuration_id' }, url: '/api/products/' },
        'getRelated': { method: 'GET', isArray: true, params: { section_id: '@section_id', configuration_id: '@configuration_id' }, url: '/api/products/:id/related' },
        'getRelations': { method: 'GET', params: { configuration_id: '@configuration_id' }, url: '/api/products/:id/relations' },
        'getFilters': { method: 'GET', url: '/api/configuration/:configurationId/filter' },
        'getSearchs': { method: 'GET', url: '/api/configuration/:configurationId/search' }
    });
    return resource;
}


// WEBPACK FOOTER //
// ./app/base/models/ProductModel.js